import { render, staticRenderFns } from "./creance.vue?vue&type=template&id=50bd4ab4&scoped=true&"
import script from "./creance.vue?vue&type=script&lang=js&"
export * from "./creance.vue?vue&type=script&lang=js&"
import style0 from "./creance.vue?vue&type=style&index=0&id=50bd4ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd4ab4",
  null
  
)

export default component.exports